<template>
  <slot name="default"></slot>
  <div
    v-if="withSeparator"
    class="
      tw-border-b tw-border-t-0 tw-border-x-0 tw-border-solid tw-m-2
      sf-dropdown-item-group__divider
    "
  />
</template>

<script setup lang="ts">
interface Props {
  withSeparator: boolean
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.sf-dropdown-item-group__divider {
  border-color: #d9d9d9;
}
</style>
